import React, { FC, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { useTranslation } from '../../../../translations';
import { Fetcher, useConvention, useFetcher } from '../../../../utils';

interface RolesSelectorProps {
  readonly selectionChanged: (userIds: number[]) => void;
}

export const RolesSelector: FC<RolesSelectorProps> = ({ selectionChanged }) => {
  const { ts } = useTranslation();
  const [role, setRole] = useState<number>(0);
  const convention = useConvention();

  const rolesListRequest = useFetcher(async () => {
    return await api.getRoles();
  }, []);

  const roleUsersRequest = useFetcher(async () => {
    if (role === 0 || !rolesListRequest.success) {
      return;
    }

    const roleItem = rolesListRequest.data.find((r) => r.id === role);
    if (!roleItem) {
      return;
    }

    const roleUsers = await api.getRoleUsers(roleItem.id);
    selectionChanged(
      roleUsers
        .filter((t) => t.conventionIds.includes(0) || t.conventionIds.includes(convention.id))
        .map((u) => u.id),
    );
  }, [role]);

  if (!rolesListRequest.success) {
    return <Fetcher result={rolesListRequest} />;
  }

  return (
    <div>
      <FormGroup>
        <Label for="role">{ts('role')}</Label>
        <Input
          disabled={roleUsersRequest.loading}
          id="role"
          name="role"
          onChange={(e) => {
            setRole(Number.parseInt(e.target.value, 10));
          }}
          type="select"
          value={role}
        >
          <option disabled value="">
            {ts('pick_one')}
          </option>
          {rolesListRequest.data.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </Input>
      </FormGroup>
    </div>
  );
};
